import * as LottiePlayer from "@lottiefiles/lottie-player";
import "@lottiefiles/lottie-player";


if ($('.card--special')[0]) {
  $('.card--special').on("mouseenter", function() {
    if ($(this).find('lottie-player')[0]) {
      $(this).find('lottie-player')[0].seek(0);
      $(this).find('lottie-player')[0].play();
    }
    
  });
}
